import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { sdk } from '@mesa-labs/mesa-api';
import usePreviewStore from './previewStore';

type AuthState = {
  isAuthenticated: boolean;
  email: string | undefined;
  groups: string[];
  permissions: sdk.AuthPermission[];
  partnerId: number | undefined;
  impersonationPartnerId: number | undefined;
  setAuthEmail: (email: string) => void;
  setAuthGroups: (groups: string[]) => void;
  setAuthPermissions: (permissions: sdk.AuthPermission[]) => void;
  setPartnerId: (id: number) => void;
  setImpersonationPartnerId: (partnerId: number) => void;
  clearAuth: () => void;
};

const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      email: undefined,
      groups: [],
      permissions: [],
      partnerId: undefined,
      impersonationPartnerId: undefined,
      setAuthEmail: (email) => set({ isAuthenticated: true, email }),
      setAuthGroups: (groups) => set({ groups }),
      setAuthPermissions: (permissions) => set({ permissions }),
      setPartnerId: (partnerId) => set({ partnerId }),
      setImpersonationPartnerId: (impersonationPartnerId) => {
        // Impersonating a real partner's account must never show fabricated preview data.
        usePreviewStore.getState().setPreviewMode(false);
        set({ impersonationPartnerId });
      },
      clearAuth: () => set({ isAuthenticated: false, email: undefined, groups: [], permissions: [], partnerId: undefined, impersonationPartnerId: undefined }),
    }),
    {
      name: 'mesa-portal-auth',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        isAuthenticated: state.isAuthenticated,
        email: state.email,
        groups: state.groups,
        permissions: state.permissions,
        partnerId: state.partnerId,
        impersonationPartnerId: state.impersonationPartnerId,
      }),
    }
  )
);

export default useAuthStore;
